import React from "react";
import { BookingStatus, STEPS, getStepStates } from "../bookingStatus";

interface Props {
  status: BookingStatus;
}

/** Four segments with step labels. The current step is marked "You are here". */
const BookingStepper: React.FC<Props> = ({ status }) => {
  if (status === "canceled") return null; // NextStepCard explains cancellation
  const states = getStepStates(status);

  return (
    <nav
      aria-label="Booking progress"
      className="rounded-2xl border border-neutral-200 dark:border-neutral-800 bg-white dark:bg-neutral-900 px-4 py-4 sm:px-6 sm:py-5"
    >
      <ol className="grid grid-cols-4 gap-2 sm:gap-3">
        {STEPS.map((step, i) => {
          const state = states[i];
          return (
            <li key={step.status} aria-current={state === "current" ? "step" : undefined} className="flex flex-col gap-2">
              <span
                className={`h-1 rounded ${
                  state === "done"
                    ? "bg-green-600 dark:bg-green-500"
                    : state === "current"
                    ? "bg-[#C2410C] dark:bg-[#FF8A6E]"
                    : "bg-neutral-200 dark:bg-neutral-800"
                }`}
              />
              <span
                className={`text-[11px] sm:text-xs leading-tight ${
                  state === "current" ? "font-semibold text-[#C2410C] dark:text-[#FF8A6E]" : "text-neutral-500 dark:text-neutral-400"
                }`}
              >
                Step {i + 1}
                {state === "current" && <span className="hidden sm:inline"> · You are here</span>}
              </span>
              <span
                className={`text-xs sm:text-sm leading-tight ${
                  state === "upcoming" ? "text-neutral-500 dark:text-neutral-400" : "font-medium text-neutral-900 dark:text-neutral-100"
                }`}
              >
                {step.label}
              </span>
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default BookingStepper;
